import reduxThunk from 'redux-thunk';

import { applyMiddleware, compose, createStore, Store } from 'redux';

import { httpMiddleware } from './middlewares/http/middleware';
import { IState, state } from './reducers';

const middlewares = [
  reduxThunk,
  httpMiddleware,
];

export const store: Store<IState> = createStore(
  state,
  compose(
    applyMiddleware(reduxThunk),
    applyMiddleware(...middlewares),
  )
);


// WEBPACK FOOTER //
// ./src/store.ts